import React from "react";
import { Gift, Package, Swords, Archive, Users, Crown, MessageSquare, FileText, X, Twitter, Instagram } from "lucide-react";

const Item = ({ Icon, label, active, badge, onClick, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`flex w-full items-center gap-3 rounded-xl px-3 py-3 text-sm font-semibold transition-colors
      ${active ? "bg-[var(--uc-primary)] text-white" : "text-[var(--uc-muted)] hover:bg-white/5 hover:text-white"}`}
  >
    <Icon className="h-5 w-5 shrink-0" /> <span className="flex-1 text-left">{label}</span>
    {badge && <span className="rounded-full bg-[var(--uc-green)] px-1.5 py-0.5 text-[9px] font-black uppercase text-black">{badge}</span>}
  </button>
);

export default function MobileMenu({ open, onClose, tab, setTab, onDailyCase, onVip, onAffiliates, onToggleChat, onProvablyFair }) {
  const go = (fn) => () => { fn(); onClose(); };
  return (
    <>
      <div onClick={onClose} className={`fixed inset-0 z-[55] bg-black/60 transition-opacity lg:hidden ${open ? "opacity-100" : "pointer-events-none opacity-0"}`} />
      <aside
        data-testid="mobile-menu"
        className={`fixed left-0 top-0 bottom-0 z-[60] flex w-[80vw] max-w-[300px] flex-col border-r border-[var(--uc-border)] bg-[var(--uc-rail)] p-4 transition-transform duration-300 lg:hidden ${open ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/uc-box-purple.png" alt="unboxcases" className="h-8 w-auto object-contain" draggable={false} />
            <span className="font-display text-lg font-extrabold lowercase text-white">unbox<span className="bg-gradient-to-r from-[#A78BFA] to-[#7C3AED] bg-clip-text text-transparent">cases</span></span>
          </div>
          <button onClick={onClose} data-testid="mobile-menu-close" className="flex h-8 w-8 items-center justify-center rounded-lg text-[var(--uc-muted)] hover:bg-white/5 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="flex-1 space-y-1 overflow-y-auto">
          <Item testid="m-daily" Icon={Gift} label="Daily Case" badge="DAILY" onClick={go(onDailyCase)} />
          <div className="my-2 h-px bg-white/10" />
          <Item testid="m-cases" Icon={Package} label="Cases" active={tab === "cases"} onClick={go(() => setTab("cases"))} />
          <Item testid="m-battles" Icon={Swords} label="Battles" active={tab === "battles"} onClick={go(() => setTab("battles"))} />
          <Item testid="m-inventory" Icon={Archive} label="Inventory" active={tab === "inventory"} onClick={go(() => setTab("inventory"))} />
          <Item testid="m-affiliates" Icon={Users} label="Affiliates" onClick={go(onAffiliates)} />
          <Item testid="m-vip" Icon={Crown} label="VIP Members" onClick={go(onVip)} />
          <div className="my-2 h-px bg-white/10" />
          <Item testid="m-chat" Icon={MessageSquare} label="Live Chat" onClick={go(onToggleChat)} />
          <Item testid="m-fair" Icon={FileText} label="Provably Fair" onClick={go(onProvablyFair)} />
        </div>

        <div className="flex items-center gap-2 pt-3">
          <a href="https://twitter.com" target="_blank" rel="noreferrer" className="flex h-9 w-9 items-center justify-center rounded-xl text-[var(--uc-muted)] hover:bg-white/5 hover:text-white"><Twitter className="h-4 w-4" /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex h-9 w-9 items-center justify-center rounded-xl text-[var(--uc-muted)] hover:bg-white/5 hover:text-white"><Instagram className="h-4 w-4" /></a>
        </div>
      </aside>
    </>
  );
}
